import { Component } from '@angular/core';
import { Router } from '@angular/router';
//import '../dbr'
@Component({
  selector: 'app-scanner',
  standalone : false,
  templateUrl: './scanner.component.html',
  styleUrl: './scanner.component.css'
})
export class ScannerComponent {
  messages: string = '';
  constructor(private readonly router: Router) { }
  async appendMessage(str: string): Promise<void> {
    this.messages = str;
    console.log("this.messages", this.messages)
    console.log("this.messages", this.messages.length)
  }
  navigateToPreviousScreen(): Promise<boolean> {
    return this.router.navigate(['']);
  }
  
}